module.exports = __webpack_public_path__ + "static/img/4636_phase_function_Paper_Points.d4a714f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4636_phase_function_Paper_Points.png
// module id = TbFE
// module chunks = 0